<!--
 * @Description: 器械管理
 * @Date: 2022-09-19 11:03:48
-->
<template>
  <XrkTable
    ref="TableRef"
    :search-config="searchConfig"
    :table-config="tableConfig"
    :get-list-ajax="getList"
  ></XrkTable>
</template>

<script lang="tsx" setup>
import {
  XrkTable,
  XrkTableProps,
  BaseButton,
  XrkTableRef,
  useInputColumn
} from 'xrk-components';
import { dealTableColumnstextLineClamp, delConfirm } from '../tools/index';
import { createDeviceFormDialog } from '../components/device-form';
import { Device } from '../data-source/types';
import { computed, ref } from 'vue';
import { useZsStore } from '../store';
import { deleteProduct, getProductList } from '../data-source/api';
import { PRODUCT_DEVICE, PRODUCT_SOURCE_CUSTOM } from '../config';

type TableConfig = XrkTableProps<Device['search'], Device['row']>;

const { isOwnPublish, isCsoRole, enterpriseId } = useZsStore();

const { TableRef, initList, initCurrentList } = (() => {
  const TableRef = ref<XrkTableRef>();
  return {
    TableRef,
    initList: () => TableRef.value?.initList(),
    initCurrentList: () => TableRef.value?.initCurrentList()
  };
})();

const searchConfig = computed(() => {
  const config: TableConfig['searchConfig'] = {
    searchColumns: [
      useInputColumn({
        prop: 'name',
        label: '器械名称',
        config: {
          maxlength: 20,
          clearable: true
        }
      }),
      useInputColumn({
        type: 'input',
        prop: 'approvalNumber',
        label: '注册证编号',
        config: {
          maxlength: 20,
          clearable: true
        }
      })
    ],
    otherComponents: []
  };
  if (isCsoRole.value) {
    config.searchColumns.unshift({
      type: 'input',
      prop: 'enterpriseName',
      label: '工业名称'
    });
  }
  if (isOwnPublish.value) {
    config.otherComponents.push({
      render: () => (
        <BaseButton
          type="primary2"
          onClick={() => createDeviceFormDialog({}, 'add', initList)}
        >
          新增
        </BaseButton>
      )
    });
  }
  return config;
});
const tableConfig = computed<TableConfig['tableConfig']>(() => {
  const config = {
    baseConfig: {},
    tableColumns: dealTableColumnstextLineClamp<
      TableConfig['tableConfig']['tableColumns']
    >([
      { type: 'index', label: '序号', width: 80 },
      { prop: 'approvalNumber', minWidth: 80, label: '注册证编号' },
      { prop: 'name', minWidth: 120, label: '器械名称' },
      { prop: 'guige', minWidth: 120, label: '型号规格' }
    ])
  };
  if (isCsoRole.value) {
    config.tableColumns.splice(1, 0, {
      prop: 'enterpriseList',
      label: '工业名称',
      minWidth: 250,
      render: ({ cellValue }) => {
        if (Array.isArray(cellValue)) {
          if (cellValue.length === 0) return <>-</>;
          return (
            <>
              {Array.from(new Set(cellValue)).map((item, index) => (
                <div style={{ padding: '3px 0', lineHeight: 1.2 }} key={index}>
                  {item}
                </div>
              ))}
            </>
          );
        }
        return <span>{cellValue || '-'}</span>;
      }
    });
  }
  if (isOwnPublish.value) {
    config.tableColumns.push({
      fixed: 'right',
      width: 150,
      label: '操作',
      render: ({ row }) => {
        return (
          <>
            <BaseButton
              type="text"
              disabled={
                !(row.allowUpdate && row.source == PRODUCT_SOURCE_CUSTOM)
              }
              onClick={() =>
                createDeviceFormDialog(row, 'edit', initCurrentList)
              }
            >
              编辑
            </BaseButton>
            <BaseButton
              type="text"
              disabled={!row.allowDelete}
              onClick={() =>
                delConfirm(async () => {
                  await deleteProduct({ id: row.id });
                  initCurrentList();
                })
              }
            >
              删除
            </BaseButton>
          </>
        );
      }
    } as TableConfig['tableConfig']['tableColumns'][number]);
  }
  return config;
});
const getList: TableConfig['getListAjax'] = async parmas => {
  return getProductList({
    ...parmas,
    type: PRODUCT_DEVICE,
    enterpriseId: enterpriseId.value
  });
};
</script>

<style></style>
